import React from "react";
import {Container} from "semantic-ui-react";
import JustificationList from "../../../components/torres/justification-components/justification-list";

const JustificationPage = () => {

    return (
        <Container style={{padding: "20px"}}>
            <JustificationList/>
        </Container>
    );
};

export default JustificationPage;
